import { axiosInstance } from "../util/wooCommerceAxios";

export class WooCommerceController {
  static getCategoriesViaSlug = async (categorySlug) => {
    try {
      const response = await axiosInstance.get(
        `products/categories?slug=${categorySlug}`
      );
      return response.data;
    } catch (error) {
      console.debug("Error fetching categories by slug:", error);
      throw error;
    }
  };

  static getSubcategoriesViaCategoryId = async (categoryId) => {
    try {
      const response = await axiosInstance.get(
        `products/categories?parent=${categoryId}`
      );
      return response.data;
    } catch (error) {
      console.debug("Error fetching subcategories by categoryId", error);
      throw error;
    }
  };

  static getProductsViaCategoryId = async (categoryId) => {
    try {
      const allProducts = [];
      let currentPage = 1;
      let totalFetched;

      do {
        const response = await axiosInstance.get(
          `products?category=${categoryId}&page=${currentPage}&per_page=100`
        );
        totalFetched = response.data.length;
        allProducts.push(...response.data);
        currentPage++;
      } while (totalFetched > 0); // Continue until no more products are fetched

      return allProducts;
    } catch (error) {
      console.debug("Error fetching products by categoryId:", error);
      throw error;
    }
  };

  static getCurrentCurrency = async () => {
    try {
      const response = await axiosInstance.get(`data/currencies/current`);
      return response.data;
    } catch (error) {
      console.debug("Error fetching current currency:", error);
      throw error;
    }
  };

  static getProductDetailsByVariationIds = async (variationIds) => {
    try {
      const productDetails = await Promise.all(
        variationIds.map(async (variationId) => {
          const response = await axiosInstance.get(`products/${variationId}`);
          return response.data;
        })
      );

      return productDetails;
    } catch (error) {
      console.debug("Error fetching product details by variation IDs:", error);
      throw error;
    }
  };
}
